<template>
    <div>
      <NavBar/>
      <div class="admin-dashboard">
        <h2>Painel de Administração</h2>
        <div class="link-container">
          <router-link to="/cadastro" class="admin-link">Cadastrar Usuário</router-link>
          <router-link to="/admin/users" class="admin-link">Gerenciamento de Usuários</router-link>
          <router-link to="/admin/players" class="admin-link">Gerenciamento de Jogadores</router-link>
          <router-link to="/admin/stages" class="admin-link">Gerenciamento de Etapas</router-link>
          <router-link to="/admin/groups" class="admin-link">Gerenciamento de Grupos</router-link>
          <router-link to="/admin/penalidades" class="admin-link">Gerenciamento de Penalidades</router-link>
        </div>
      </div>
    </div>
  </template>
  
  <script>
  import NavBar from '../components/NavBar.vue';
  
  export default {
    name: 'PaginaAdmin',
    components: {
      NavBar
    }
  };
  </script>
  
  <style scoped>
  .admin-dashboard {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    min-height: 100vh;
    background-color: #F0F4F7;
    padding: 2rem;
  }
  
  .admin-dashboard h2 {
    margin-bottom: 2rem;
    color: #003366;
    font-size: 2.5rem;
    text-align: center;
  }
  
  .link-container {
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 1rem;
    width: 100%;
    max-width: 400px;
  }
  
  .admin-link {
    text-decoration: none;
    color: white;
    background-color: #0056B3;
    padding: 1rem 2rem;
    border-radius: 8px;
    font-size: 1.2rem;
    transition: background-color 0.3s, transform 0.3s;
    width: 100%;
    text-align: center;
  }
  
  .admin-link:hover {
    background-color: #003366;
    transform: scale(1.05);
  }
  
  @media (max-width: 768px) {
    .admin-link {
      font-size: 1rem;
      padding: 0.75rem 1.5rem;
    }
  
    .admin-dashboard h2 {
      font-size: 2rem;
    }
  }
  
  @media (max-width: 425px) {
    .admin-link {
      font-size: 0.9rem;
      padding: 0.5rem 1rem;
    }
  
    .admin-dashboard h2 {
      font-size: 1.5rem;
    }
  }
  </style>
  